import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import { CheckAPIHealth } from "../../Utils/ProstewardAPI.js";
import { useTranslation } from "react-i18next";
import {Failsafefallback} from "../FallbackPages/Fallback.js";
import "@progress/kendo-theme-default";
import Searchform from "../Searchform/Searchform.js";
import "./body.css";
const clean = DOMPurify.sanitize;
const MainContent = () => {
  const [fallback, setfallback] = useState(null);
  let apihealth = async () => {
    let res = await CheckAPIHealth();
    return !res.isvalid;
  };
  useEffect(async () => {
    setfallback(await apihealth());
  }, []);
  const { t } = useTranslation();

  return (
    <>
      {fallback ? (
        <Failsafefallback />
      ) : (
        <>
          {/* INFO BOX */}
          <div className="info-section">
            <div className="black-box">
              <p className="Graphik-Bold-Web">{t("safetyDataSheets")}</p>
            </div>
          </div>
          {/* MAIN BODY */}
          <div className="body-content Graphik-Light-Web">
            <p>{t("bodyContentParagraph1")}</p>
            <p>{t("bodyContentParagraph2")}</p>
            <p>{t("bodyContentParagraph3")}</p>
            <ol type="number">
              <li>{t("bodyContentList1")}</li>
              <br />
              <li>{t("bodyContentList2")}</li>
              <br />
              <li>
                <span>
                  <p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: clean(t("bodyContentList3")),
                      }}
                    />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: clean(t("bodyContentList4")),
                      }}
                    />
                  </p>
                </span>
              </li>
              <li>{t("bodyContentList5")}</li>
            </ol>

            {/* SEARCH SECTION */}
            <Searchform />

            <p>
              <div
                dangerouslySetInnerHTML={{
                  __html: clean(t("inquiriesSentTo")),
                }}
              />
            </p>

            <p>
              <strong className="Graphik-Semibold-Web">
                {t("platesAndEquipment")}
              </strong>
              <br />
              {t("platesAndEquipmentContent")}
            </p>

            <p>
              <strong className="Graphik-Semibold-Web">
                {t("kodakBrandPartner")}
              </strong>
              <br />
              {t("kodakBrandPartnerContent")}
            </p>

            <p>
              <strong className="Graphik-Semibold-Web">{t("batteries")}</strong>
              <br />
              <div
                dangerouslySetInnerHTML={{ __html: clean(t("strandEurope")) }}
              />
            </p>

            <p>
              <strong className="Graphik-Semibold-Web">
                {t("consumerAndProfessionalPhotographicProducts")}
              </strong>
              <br />
              <div
                dangerouslySetInnerHTML={{ __html: clean(t("kodakAlaris")) }}
              />
            </p>
            <p>
              <b>{t("divestedProducts")}</b>
              <br />
              {t("devistedProductsContent")}
            </p>
            <p>
              <strong className="Graphik-Semibold-Web">
                {t("medicalDentalAndIndustrialXrayProducts")}
              </strong>
              <br />
              <div
                dangerouslySetInnerHTML={{
                  __html: clean(t("carestreamHealth")),
                }}
              />
            </p>
            <p>
              <strong className="Graphik-Semibold-Web">
                {t("laboratoryAndResearchChemicals")}
              </strong>
              <div
                dangerouslySetInnerHTML={{
                  __html: clean(t("fisherChemicalCompany")),
                }}
              />
            </p>
            <p>
              <strong className="Graphik-Semibold-Web">
                {t("fibersAndPlastics")}
              </strong>
              <div
                dangerouslySetInnerHTML={{
                  __html: clean(t("eastmanChemicalCompany")),
                }}
              />
            </p>
          </div>
        </>
      )}
    </>
  );
};

export default MainContent;
